/* global $ */

const Sidebar = {
  create(node) {
    this.$sidebar = $(node).find('.js-media-sidebar');
    this.hiddenPage = node.querySelector('.js-media-page');

    this.createEvents();
  },

  createEvents() {
    this.$sidebar.on('change', 'input[type="checkbox"]', this.handleCheck.bind(this));
  },

  /**
   * Handle the checking of checkboxes in the sidebar
   * @param {Object} e Event object
   * @return {Void}
   */
  handleCheck(e) {
    this.handleCheckedAll(e);

    this.hiddenPage.value = 1;

    window.pubsub.publish('media:filter');
  },

  handleCheckedAll({ currentTarget }) {
    const $el = $(currentTarget);

    // Is the 'All files' box checked?
    const checkedAll = !!$el.data('all');

    // Get all :checked checkboxes
    const $checked = this.$sidebar.find('input:checked');

    // If we check the all checkbox we deselect all other checkboxes
    if (checkedAll && currentTarget.checked) {
      $checked.filter(':not([data-all])').prop('checked', false);
      return;

    // If we deselect the all checkbox, select it again if nothing else is checked
    } else if (checkedAll && !$checked.length) {
      currentTarget.checked = true;
      return;
    }

    // Disable the all files checkbox
    this.$sidebar.find('[data-all]')[0].checked = !$checked.length;
  },
};

export default Sidebar;
